import React from 'react';
import { Award, Users } from 'lucide-react';
import { mockData, images } from '../utils/mock';

export const AboutFounder = () => {
  return (
    <section id="quien" className="relative py-24 bg-gradient-to-b from-black to-zinc-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Quién Está Detrás
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src={images.founder}
                alt={mockData.founder.name}
                className="w-full h-[550px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              
              {/* Name Badge */}
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-black/60 backdrop-blur-md p-6 rounded-xl border border-white/10">
                  <h3 className="text-2xl font-bold text-white mb-2">
                    {mockData.founder.name}
                  </h3>
                  <p className="text-orange-500 font-semibold">
                    {mockData.founder.title}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <div className="space-y-6 mb-10">
              {mockData.founder.bio.map((paragraph, index) => (
                <p
                  key={index}
                  className={`text-lg leading-relaxed ${
                    paragraph === 'No es teoría.' || paragraph === 'Es experiencia aplicada.'
                      ? 'text-white font-bold text-xl'
                      : 'text-white/80'
                  }`}
                >
                  {paragraph}
                </p>
              ))}
            </div>

            {/* Highlights */}
            <div className="grid sm:grid-cols-2 gap-6">
              <div className="p-6 bg-black/40 border border-white/10 rounded-xl hover:border-orange-500/50 transition-all duration-300 group">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-orange-500/20 rounded-lg mb-4 group-hover:bg-orange-500/30 transition-colors duration-300">
                  <Award className="w-6 h-6 text-orange-500" />
                </div>
                <h4 className="text-white font-semibold mb-2">Agente FIFA</h4>
                <p className="text-white/70 text-sm">
                  Licencia oficial para representar futbolistas profesionales
                </p>
              </div>

              <div className="p-6 bg-black/40 border border-white/10 rounded-xl hover:border-orange-500/50 transition-all duration-300 group">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-orange-500/20 rounded-lg mb-4 group-hover:bg-orange-500/30 transition-colors duration-300">
                  <Users className="w-6 h-6 text-orange-500" />
                </div>
                <h4 className="text-white font-semibold mb-2">Experiencia Real</h4>
                <p className="text-white/70 text-sm">
                  Acompañando carreras masculinas y femeninas de alto nivel
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
